export const PLATFORM_REPORT_BRAND_LOADED="PLATFORM_REPORT_BRAND_LOADED";


export const platformBrand=(data)=>(dispatch)=>{{
    // console.log(data,"data1")
    dispatch(({
        type:PLATFORM_REPORT_BRAND_LOADED,
        payload:data
    }))
}}

